import React, { useState, useEffect } from "react";
import { Card, Row, Col, Badge } from "react-bootstrap";
import {
  FaReceipt,
  FaUsers,
  FaCheckCircle,
  FaClock,
  FaTimesCircle,
} from "react-icons/fa";
import { gastosService } from "../services/api";
import { useAuth } from "../context/AuthContext";

const Dashboard = () => {
  const { user, isAdmin } = useAuth();
  const [stats, setStats] = useState({
    totalGastos: 0,
    gastosPendientes: 0,
    gastosValidados: 0,
    gastosRechazados: 0,
    totalMonto: 0,
  });

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      // Obtener todos los gastos para calcular estadísticas
      const response = await gastosService.getAll({ limit: 1000 });
      const gastos = response.data.gastos;

      const stats = {
        totalGastos: gastos.length,
        gastosPendientes: gastos.filter((g) => g.estado === "Pendiente").length,
        gastosValidados: gastos.filter((g) => g.estado === "Validado").length,
        gastosRechazados: gastos.filter((g) => g.estado === "Rechazado").length,
        totalMonto: gastos.reduce((sum, g) => sum + parseFloat(g.monto), 0),
      };

      setStats(stats);
    } catch (error) {
      console.error("Error cargando estadísticas:", error);
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("es-ES", {
      style: "currency",
      currency: "EUR",
    }).format(amount);
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="mb-0">Dashboard</h2>
        {/* Botón oculto - movido a EmpleadosList */}
        {/* <Button
          variant="outline-primary"
          size="sm"
          onClick={() => setShowAjustarHorasModal(true)}
          title="Ajustar horas trabajadas/planificadas"
        >
          <FaBalanceScale className="me-2" />
          Ajustar horas
        </Button> */}
      </div>

      <Row>
        <Col md={3} className="mb-3">
          <Card className="text-center">
            <Card.Body>
              <FaReceipt size={40} className="text-primary mb-2" />
              <Card.Title>Total Gastos</Card.Title>
              <h3 className="text-primary">{stats.totalGastos}</h3>
            </Card.Body>
          </Card>
        </Col>

        <Col md={3} className="mb-3">
          <Card className="text-center">
            <Card.Body>
              <FaClock size={40} className="text-warning mb-2" />
              <Card.Title>Pendientes</Card.Title>
              <h3 className="text-warning">{stats.gastosPendientes}</h3>
            </Card.Body>
          </Card>
        </Col>

        <Col md={3} className="mb-3">
          <Card className="text-center">
            <Card.Body>
              <FaCheckCircle size={40} className="text-success mb-2" />
              <Card.Title>Validados</Card.Title>
              <h3 className="text-success">{stats.gastosValidados}</h3>
            </Card.Body>
          </Card>
        </Col>

        <Col md={3} className="mb-3">
          <Card className="text-center">
            <Card.Body>
              <FaTimesCircle size={40} className="text-danger mb-2" />
              <Card.Title>Rechazados</Card.Title>
              <h3 className="text-danger">{stats.gastosRechazados}</h3>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col md={6} className="mb-3">
          <Card>
            <Card.Header>
              <h5 className="mb-0">Resumen Financiero</h5>
            </Card.Header>
            <Card.Body>
              <h4 className="text-success">
                {formatCurrency(stats.totalMonto)}
              </h4>
              <p className="text-muted">Total de gastos registrados</p>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6} className="mb-3">
          <Card>
            <Card.Header>
              <h5 className="mb-0">Información del Usuario</h5>
            </Card.Header>
            <Card.Body>
              <p>
                <strong>Nombre:</strong> {user?.nombre}
              </p>
              <p>
                <strong>Crew ID:</strong> {user?.crewID}
              </p>
              <p>
                <strong>Rol:</strong>
                <Badge
                  bg={user?.rol === "admin" ? "danger" : "primary"}
                  className="ms-2"
                >
                  {user?.rol}
                </Badge>
              </p>
              {user?.telefono && (
                <p>
                  <strong>Teléfono:</strong> {user.telefono}
                </p>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
